import { StoreUserState, StoreUser } from '@/types'

export const SET_USER = 'SET_USER'

export default {
  [SET_USER]: (state: StoreUserState, payload: StoreUser) => {
    state.loggedUser = payload
  }
}